import React, { useState } from 'react';
import { MapPin, Mail, Phone } from 'lucide-react';

const ContactForm = () => {
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSent(false);
    setError(false);

    const formData = new FormData(e.target);

    try {
      const res = await fetch('https://formspree.io/f/xblyzvrq', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });

      if (res.ok) {
        setSent(true);
        e.target.reset();
      } else {
        setError(true);
      }
    } catch (err) {
      setError(true);
    }
  };

  return (
    <section className="bg-[#fdfcf9] py-16 px-4" id="kontakt">
      <div className="max-w-2xl mx-auto mb-10 text-center">
        <p className="text-[#d2a391] uppercase text-sm tracking-[0.2em] mb-2">
          Kontakt
        </p>
        <h2 className="text-3xl md:text-4xl font-alike text-darkGrey">
          Skontaktuj się z nami
        </h2>
      </div>

      <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
        {/* Dane kontaktowe */}
        <div className="space-y-6 text-darkGrey">
          <h3 className="text-xl font-alike mb-2">Dane kontaktowe</h3>

          <div className="flex items-start gap-4">
            <MapPin className="text-[#d2a391] mt-1" />
            <div>
              <p>ul. Rynek 11 38-600 Lesko</p>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <Mail className="text-[#d2a391]" />
            <a href="mailto:marciniec21@gmail.com">marciniec21@gmail.com</a>
          </div>

          <div className="flex items-center gap-4">
            <Phone className="text-[#d2a391]" />
            <a href="tel:665189478">+48 665 189 478</a>
          </div>
        </div>

        {/* Formularz */}
        <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input
              type="text"
              name="name"
              placeholder="Imię"
              required
              className="w-full border border-[#e8e4dc] rounded-md px-4 py-2 text-darkGrey placeholder-grey focus:outline-none focus:ring-2 focus:ring-[#d2a391]"
            />
            <input
              type="tel"
              name="phone"
              placeholder="Telefon"
              className="w-full border border-[#e8e4dc] rounded-md px-4 py-2 text-darkGrey placeholder-grey focus:outline-none focus:ring-2 focus:ring-[#d2a391]"
            />
          </div>

          <input
            type="email"
            name="email"
            placeholder="Adres email"
            required
            className="w-full border border-[#e8e4dc] rounded-md px-4 py-2 text-darkGrey placeholder-grey focus:outline-none focus:ring-2 focus:ring-[#d2a391]"
          />

          <textarea
            name="message"
            rows="5"
            placeholder="Wiadomość"
            required
            className="w-full border border-[#e8e4dc] rounded-md px-4 py-2 text-darkGrey placeholder-grey focus:outline-none focus:ring-2 focus:ring-[#d2a391]"
          />

          <div className="pt-2 text-center">
            <button
              type="submit"
              className="bg-[#d2a391] text-white font-semibold px-6 py-2 rounded uppercase tracking-wider hover:brightness-110 transition"
            >
              Wyślij wiadomość
            </button>
          </div>

          {sent && (
            <p className="text-green-600 text-sm text-center mt-2">
              Wiadomość została wysłana. Dziękujemy!
            </p>
          )}
          {error && (
            <p className="text-red-600 text-sm text-center mt-2">
              Wystąpił błąd. Spróbuj ponownie później.
            </p>
          )}
        </form>
      </div>
    </section>
  );
};

export default ContactForm;
